<template>
    <div class="c-bubble" @mouseleave="level1Index = -1;level2Index=0;level3Index=-1">
        <div class="c-bubble-inner" 
        v-for="(item1, index1) in listData"
        :key="index1" v-if="level1Index == index1">
            <div class="nav-dropdown-menu-all">
                <div class="subnav-two">
                    <div class="container">
                        <div class="center-box">
                            <div class="levle_2_contain">
                                <div v-for="(item2, index2) in item1.children"
                                    class="levle_2_div"
                                    :class="level2Index == index2 ? 'active' : ''"
                                    :key="index2"
                                    :style="{
                                        '--level_2_bgckgroundColor':pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type === 'color' ? pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].color : 'transparent',
                                        '--level_2_backgroundImage':pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type !== 'color' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].img ? `url(${pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].img})` : 'none',
                                        '--level_2_backgroundSize':pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type !== 'color' ? pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].background_size : 'unset',
                                        '--level_2_backgroundRepeat':pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type !== 'color' ? pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].background_repeat : 'unset',
                                        '--level_2_backgroundPosition': pc_widgets_infor.navChildSeBackground.radio_val !== 'hidden' && pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].type !== 'color' ? pc_widgets_infor.navChildSeBackground[pc_widgets_infor.navChildSeBackground.radio_val].background_position : 'unset'
                                    }"
                                    >
                                    <span class="levle_2"
                                    :style="[{
                                        textAlign: pc_widgets_infor.navChildtextAlign
                                        },level2Index == index2 ? ch_SefontStyle : ch_fontStyle]"
                                    @mouseenter="hoverChange(index2)"
                                    @click="toPage(item2)"
                                    >{{item2.name}}</span>
                                    </div>
                            </div>
                            <div class="box">
                                <div v-for="(item2, index2) in item1.children" 
                                v-if="level2Index == index2"
                                :key="index2">
                                    <div class="centerbox">
                                      <div class="middbox_contain">
                                            <div class="middbox">
                                                <span v-for="(item3, index3) in item2.children" 
                                                :key="index3"
                                                @mouseenter="level3Index = index3"
                                                @mouseleave="level3Index = -1" 
                                                @click="toPage(item3)" 
                                                :style="[{
                                                    textAlign: pc_widgets_infor.navChildtextAlign 
                                                    },level3Index == index3 ? ch2_SefontStyle : ch2_fontStyle]">{{item3.name}}</span>
                                            </div>
                                        </div>                  
                                        <div class="rightbox">
                                            <div class="pic">
                                                <img :src="item2.icon" class="vcenter" 
                                                v-if="item2.icon
                                                && item2.icon !== '' 
                                                && item2.icon !== null">
                                                <img v-else src="https://sitecdn.71360.com/static/txys-001/image/noimage.jpg"  class="vcenter">
                                            </div>                                
                                        </div>
                                    </div> 
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: 'navbar_dialog',
  data () {
    return {
        level1Index: this.activeIndex,
        level2Index: 0,
        level3Index: -1
    }
  },
  props: {
    listData: {
      type: Array,
      default: []
    },
    pc_widgets_infor: {
      type: Object,
      default: {}
    },
    activeIndex: {
        type: Number,
        default: -1
    }
  },
  computed: {
    ch_fontStyle () {
      return this.createFontStyle(this.pc_widgets_infor.navChildfont);
    },
    ch_SefontStyle () {
      return this.createFontStyle(this.pc_widgets_infor.navChildfont, 'se');
    },
    ch2_fontStyle () {
      return this.createFontStyle(this.pc_widgets_infor.navChildfont, '', 'ch2');
    },
    ch2_SefontStyle () {
      return this.createFontStyle(this.pc_widgets_infor.navChildfont, 'se', 'ch2');
    }
  },
  watch: {
    activeIndex(val) {
        this.level1Index = val
      }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    createFontStyle (infor, type = "", levelType = "") {
        const obj = {};
        if (levelType == 'ch2') {
        obj.fontSize = parseInt(infor[infor.radio_val].fontSize) + 'px';
        } else {
        obj.fontSize = infor[infor.radio_val].fontSize + 'px';
        }
        obj.fontFamily = infor[infor.radio_val].fontFamily;
        obj.fontWeight = infor[infor.radio_val].fontWidth;
        obj.fontStyle = infor[infor.radio_val].fsItalics;

        obj.textDecoration = infor[infor.radio_val].fontUnderline;
        let pattern = '';
        let linear_gradient = {};
        if (type === 'se') {
        pattern = infor[infor.radio_val].sePattern;
        linear_gradient = infor[infor.radio_val].seLinear_gradient;
        obj.color = pattern === 'pure_color' ? infor[infor.radio_val].fontSeColor : '';
        } else {
        pattern = infor[infor.radio_val].pattern;
        linear_gradient = infor[infor.radio_val].linear_gradient;
        obj.color = pattern === 'pure_color' ? infor[infor.radio_val].fontColor : '';
        }
        obj.webkitTextFillColor = pattern === 'linear_gradient' ? 'transparent' : '';
        if (pattern === 'linear_gradient') {
        obj.backgroundImage =
            'linear-gradient(' +
            linear_gradient.deg +
            'deg,' +
            linear_gradient.start_color +
            linear_gradient.start_pointer +
            '%,' +
            linear_gradient.end_color +
            linear_gradient.end_pointer +
            '%)';
        } else {
        obj.backgroundImage = '';
        }
        return obj;
    },
      hoverChange(val) {
        this.level2Index = val
      },
      toPage (item, type = 'true') {
        if (this.$store.state.app.view_pattern === 'mb') {
            $('.mobile_header .navPart').removeClass('active');
            $('.mobile_header .menuPart').removeClass('activeIcon');
        }
        if (type === 'false' && item.children.length > 0) {
            return false;
        }
        // if (this.$route.path === '/' + item.theme_name) {
        //   return false;
        // }
        if (item.type === 'Logoimg') {
            return false;
        }
        let that = this;
        if (this.$store.state.app.is_change) {
            if (item.module === 'anchor') {
            let link = item.theme_name.split('#');
            let anchorType = 'other_page';
            if (link[0] == '/') link[0] = 'index:index';
            let id = link[1];
            let path = '';
            let urlList = this.$store.state.app.websiteSection;
            urlList.map(e => {
                if (e.module == link[0]) {
                path = e.routerPath;
                }
                if (e.routerPath === this.$store.state.app.now_page && e.module == link[0]) {
                anchorType = 'cur_page';
                }
            });
            if (!path) {
                this.$message.warning({
                showClose: true,
                message: i18n.t('base_row_jcp_1921')
                });
                return false;
            }
            if (anchorType === 'cur_page') {
                this.templet.active_anchor(anchorType, id, path);
                return false;
            }
            }
            this.$confirm(i18n.t('widgets_basic_article_info_index_360'), i18n.t('view_public_topbar_23'), {
            confirmButtonText: i18n.t('widgets_basic_article_info_index_361'),
            cancelButtonText: i18n.t('view_public_topbar_11'),
            center: true,
            // customClass: 'del_dialog',
            appendToBody: true
            })
            .then(() => {
                this.templet.toPage(item);
            })
            .catch(() => {
            });
        } else {
            this.templet.toPage(item);
        }
        }
  }
}
</script>

<style lang="scss" scoped>
.c-bubble {
    text-align: center;
    left: 0;
    top: 253px;
    width: 100%;
    z-index: 1999;
    position: fixed;
    box-sizing: border-box;
    padding-left: 0px;
    cursor: default;
}
.c-bubble .c-bubble-inner {
    display: inline-block;
    width: 100%;
}
.nav-dropdown-menu-all {
    width: 100%;
    min-height: 310px;
}
.subnav-two {
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    border-top: solid 1px #ddd;
    border-bottom: solid 1px #ccc;
    background-color: #f4f4f4;
}
.nav-dropdown-menu-all .container {
    position: relative;
}
.container {
    width: 100%;
    max-width: 1200px;
    position: relative;
    height: 100%;
    margin: 0 auto;
    padding: 0 !important;
    overflow: hidden;
    display: flex;
}
.subnav-two .center-box {
    width: 100%;
    font-size: 16px;
    padding: 0 0 0 15px;
    display: flex;
}
.subnav-two .center-box .levle_2_contain {
    display: block;
    position: relative;
    min-height: 310px;
    width: 250px;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 432px;
    background-color: #f4f4f4;
}
.subnav-two .center-box .levle_2 {
    display: block;
    text-align: left;
    margin: 0;
    width: 250px;
    background-color: #f4f4f4;
    z-index: 1;
    position: relative;
    cursor: pointer;
    padding: 15px 45px 15px 45px;
    -webkit-transition: all 0s ease-in;
    transition: all 0s ease-in;
    -webkit-background-clip: text;
    margin-bottom: 5px;
}
.subnav-two .box {
    width: calc(100% - 250px);
    background-color: #fff;
    height: 100%;
    min-height: 310px;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 432px;
}
.subnav-two .middbox_contain {
    width: calc(100% - 510px);
    padding: 20px 35px 0 35px;
}
.subnav-two .middbox span {
    width: 100%;
    color: #444;
    cursor: pointer;
    text-align: left;
    font-size: 14px;
    display: block;
    line-height: 28px;
    padding-bottom: 10px;
    -webkit-background-clip: text;
}
.subnav-two .rightbox {
    width: 100%;
    margin:20px;
}
.subnav-two .rightbox .pic {
    width: 100%;
    height: 385px;
    position: relative;
}
.subnav-two .rightbox .pic img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    max-width: 100%;
    max-height: 100%;
    display: block;
    text-align: center;
    margin: auto;
}
.subnav-two .rightbox p {
    font-size: 15px;
    color: #777;
    margin-top: 10px;
    overflow: hidden;
    line-height: 22px;
    text-align: left;
}
.c-bubble .c-bubble-inner:after, .c-bubble .c-bubble-inner:before {
    font-size: 0;
    position: absolute;
    width: 0;
    height: 0;
    content: '';
    border: 8px dashed transparent;
}
.subnav-two .center-box .levle_2_contain:after {
    left: -165%;
    top: 0;
    height: 100%;
    content: "";
    opacity: 0;
    position: absolute;
}
.subnav-two .center-box .levle_2_contain:hover:after {
    opacity: 1;
}
.subnav-two .center-box .levle_2:hover .levle_2_div,
.subnav-two .center-box .levle_2_div.active {
    color: #fff;
    background-color: var(--level_2_bgckgroundColor) !important;
    background-image: var(--level_2_backgroundImage) !important;
    background-size: var(--level_2_backgroundSize) !important;
    background-repeat: var(--level_2_backgroundRepeat) !important;
    background-position: var(--level_2_backgroundPosition) !important;
}
.centerbox {
    display: flex;
}
</style>


// WEBPACK FOOTER //
// src/widgets/basic_navbar/components/navbar_dialog.vue